module.exports = __webpack_public_path__ + "list_view.a4aa6fdf.webp";